// extracted by mini-css-extract-plugin
export default {"modal":"modal___Rpu6e","goto1":"goto1___YAUMI","goto2":"goto2___efKsH"};